import { render, staticRenderFns } from "./NatureOfAccidentList.vue?vue&type=template&id=0c5c72f6"
import script from "./NatureOfAccidentList.vue?vue&type=script&lang=js"
export * from "./NatureOfAccidentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports